import IconListWithText from './IconListWithText'

export default IconListWithText
